import React, {FC} from 'react'

export const DiagramIcon: FC = () => (
    <svg className='canvas-toolbar__icon' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
        <circle cx='6' cy='6' r='3'/>
        <circle cx='18' cy='6' r='3'/>
        <circle cx='6' cy='18' r='3'/>
        <circle cx='18' cy='18' r='3'/>
        <line x1='9' y1='6' x2='15' y2='6'/>
        <line x1='6' y1='9' x2='6' y2='15'/>
        <line x1='18' y1='9' x2='18' y2='15'/>
        <line x1='9' y1='18' x2='15' y2='18'/>
        <line x1='8.5' y1='8.5' x2='15.5' y2='15.5'/>
    </svg>
)
